import { BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Hero = () => {
  const scrollToShelf = () => document.getElementById("shelf")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section data-testid="hero-section" className="texture-grain relative overflow-hidden">
      <img
        src="/hero-bg.jpg"
        alt="Aurora over the frozen ridges of Avalon"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-background/60" />
      <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-background/30" />
      <div className="relative z-10 mx-auto max-w-6xl px-6 py-32 md:py-44">
        <p className="text-xs uppercase tracking-[0.3em] text-primary">avali-archive.space</p>
        <h1 className="mt-6 max-w-2xl font-display text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">
          Every tome of the Avali, bound in ice and light.
        </h1>
        <p className="mt-6 max-w-xl text-base text-muted-foreground md:text-lg">
          A Kindle-quiet reading room for the lore of Avalon. Pick a tome from
          the shelf and leaf through its plates — arrow keys, a swipe, or the
          turn of a page at a time.
        </p>
        <div className="mt-10 flex flex-wrap items-center gap-4">
          <Button
            data-testid="browse-shelf-btn"
            onClick={scrollToShelf}
            className="lamp-shadow rounded-full px-6 transition-transform duration-200 hover:-translate-y-0.5"
          >
            <BookOpen className="mr-2 h-4 w-4" />
            Browse the shelf
          </Button>
          <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground">
            5 tomes catalogued
          </p>
        </div>
      </div>
    </section>
  );
};
